function positiveId(id: number): number {
  if (!Number.isSafeInteger(id) || id <= 0) {
    throw new RangeError("workingTemplateIdx must be a positive integer");
  }
  return id;
}

export const workingTemplateCommuteSettingsRoutes = {
  settings: (workingTemplateIdx: number) =>
    `/api/working-templates/${encodeURIComponent(
      String(positiveId(workingTemplateIdx))
    )}/commute-settings`
} as const;

export default workingTemplateCommuteSettingsRoutes;
